import R from 'ramda'

const OWNER_TWEET_TRIGGER_TYPE = 'FROM'
const OWNER_TWEET_DISPLAY_TYPE = "Owner's Tweet"

const isOwnerTweetWidgetTrigger = R.allPass([
  R.propEq('type', OWNER_TWEET_TRIGGER_TYPE),
  R.propSatisfies(R.not, 'negate'),
  R.propEq('primary', true)
])

const convertOwnerTweetWidgetTriggerToFormTrigger = R.applySpec({
  type: R.always(OWNER_TWEET_DISPLAY_TYPE)
})

export {
  isOwnerTweetWidgetTrigger,
  convertOwnerTweetWidgetTriggerToFormTrigger
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/widget-to-form/owner-tweet.js